import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-10 px-4 border-t border-gray-100" data-id="element-86">
      <div className="max-w-2xl mx-auto text-center" data-id="element-87">
        <div className="flex flex-col items-center gap-4" data-id="element-88">
          <ShieldCheckIcon className="w-12 h-12 text-[#111827]" data-id="element-89" />
          <p className="text-lg md:text-xl font-medium text-[#111827]" data-id="element-90">
            Garantía 7 días sin riesgo. Si no cumple tus expectativas, podés
            solicitar la devolución.
          </p>
        </div>
      </div>
    </section>;
}